import { Component, createRef } from "react";
import { connect } from "react-redux";

import {set_datapage,getMapStateDefault} from '@ora/recursos/src/redux/actions/DataPageAction'
import { Templates } from "@ora/recursos";
import Swal from 'sweetalert2'
import {
  Card, 
  Section
   } from 'react-bulma-components';
import axios from "axios";
import { baseUrl, localUrl } from "@ora/recursos/src/helpers/Url";
import InputsCreate from "layouts/mainsection/components/InputsCreate";
import '@loadingio/loading.css/dist/loading.css'


class CuotasExportacionCreate extends Component {
  isEdit = false
  _isMounted = false;
  requestInit = null
  inputs = []
  idrecurso = 0
  state = {
    recursos: [],
    tipos: [],
    mimes: [],
    pais: [],
    idioma: [],
    sublinea: [],
    data: null
  }
  constructor (props) {
    super(props)
    

    
    this.frmCreate = createRef()
    this.refTxtUrl = createRef()
    let { idrecurso } = this.props.match.params
    if (idrecurso !== undefined) {
      this.isEdit = true
      this.idrecurso = idrecurso
    }
    this.spinnerLoad = createRef()
    
  }
  componentWillUnmount() {
    this._isMounted = false;
    if (this.requestInit) this.requestInit.cancel()
  }
  componentDidMount () {
    this._isMounted = true;
    this.requestInit = axios.CancelToken.source()

    this.props.set_datapage({ titulo: (this.isEdit ? 'Editar' : 'Crear') + ' cuotas de exportación',
    isbackend:true,
    breadcrumb:[
        {name:"Intranet",url:"#"},
        {name:"Cuotas de exportacion",url:"#"},
        {name: (this.isEdit ? 'Editar' : 'Crear') + " cuotas de exportación",url:"#",active:true},
    ]});

    axios.get(baseUrl('cites/cuotasexportacion/create'), { cancelToken: this.requestInit.token }).then(res => {
      this.inputs = res.data.data
    }).then(successC => {
      axios.get(baseUrl('cites/cuotasexportacion'), { cancelToken: this.requestInit.token }).then(res => {
        if (res.data.success) {
          this.setState({
                recursos: res.data.data.recursos,
                // tipos: res.data.data.tipo,
                // mimes: res.data.data.mimes,
                // pais: res.data.data.pais,
                idioma: res.data.data.idioma,
                // sublinea: res.data.data.sublinea,
            })
        }

      }).then(success => {
  
        if (this.isEdit) {
          axios.get(baseUrl('cites/cuotasexportacion/' + this.idrecurso), { cancelToken: this.requestInit.token }).then(res => {
            if (res.data.success) {
              // this.setState({
              //     data: res.data.data
              // })
          
              this.inputs.forEach((item, index) => {
                if (this.frmCreate.current.elements[item.key] !== undefined) {
                  switch (item.key) {
                    // case 'cue_bit_amazonian':
                    //   this.frmCreate.current.elements[item.key].checked = res.data.data[item.key] == '1' ? true : false
                    //   break;
                  
                    default:
                      this.frmCreate.current.elements[item.key].value = res.data.data[item.key]
                      break;
                  }
                }
              })
              this.spinnerLoad.current.classList.add('is-hidden')
              this.frmCreate.current.classList.remove('is-hidden')
           
          }
          })
        
      } else {
        this.spinnerLoad.current.classList.add('is-hidden')
        this.frmCreate.current.classList.remove('is-hidden')
      }
      })
    })

    // axios.get(baseUrl('cites/pais/actives')).then(res => {
    //   if (res.data.success) {
    //       this.setState({
    //           pais: res.data.data
    //       })
    //   }
    // })
    // axios.get(baseUrl('aro/lenguaje/actives')).then(res => {
    //   if (res.data.success) {
    //       this.setState({
    //           idioma: res.data.data
    //       })
    //   }
    // })
  }
  componentDidUpdate () {
    
  }
  onChange = evt => {
    // if (evt.target.name === 'duc_txt_file') {
    //   console.log(evt.target.files)
    //   if (evt.target.files.length > 0)
    //   this.refTxtUrl.current.value = evt.target.files[0].name
    // }
  }
  onClick_regresar = evt => {
    this.props.history.push(localUrl('/config/cuotasexportacion'))
  }
  OnSubmit_create = evt => {
    evt.preventDefault()
    let data = new FormData(this.frmCreate.current)
    if (this.isEdit) {
      data.append('cue_int_id', this.idrecurso)
    }
    axios({
      method: this.isEdit ? 'post' : 'post',
      url: baseUrl('cites/cuotasexportacion'), 
      // url: baseUrl('aro/documentos' + (this.isEdit ? `/${this.idrecurso}` : '')), 
      // data: this.isEdit ? Object.fromEntries(data)  : data
      data: data
    }).then(res => {
      if (res.data.success) {
        this.frmCreate.current.reset()
        Swal.fire(
          'Cuotas de exportación',
          res.data.message,
          'success'
        ).then(sr => {
          if (this.isEdit) {
            this.onClick_regresar()
            // this.props.history.push(localUrl('config/recursos'))
          }
        })
      }
    })

  }
  COptionRecursos = () => {
    return this.state.recursos.map((item, index) => {
      return <option key={ index } value={ item.id }>{ item.name }</option>
    })

  }
  COptionPais = () => {
    return this.state.pais.map((item, index) => {
      return <option key={ index } value={ item.id }>{ item.name }</option>
    })

  }
  COptionLenguaje = () => {
    return this.state.idioma.map((item, index) => {
      return <option key={ index } value={ item.id }>{ item.name }</option>
    })

  }
  inputsDefault = () => {
    return this.inputs.map((item, index) => {

      let dataSelect = []
      switch (item.key) {
        case 'lan_txt_language':
          dataSelect = this.COptionLenguaje()
          break;
        case 'rec_int_id':
          dataSelect = this.COptionRecursos()
          break;
        default:
          break;
      }
      if (!['cue_int_id', 'cue_sts_registro'].includes(item.key))
        return (<InputsCreate 
          nameKey={ item.key } 
          minLength={ item.min } 
          limit={ item.limit } 
          maxLength={ item.max }  
          placeholder={ item.placeholder }  
          key={ index } 
          checkedBoolean={ true }
          label={ item.name } 
          forSelect= { {data: dataSelect} }
          type={ item.type}/>)
      else return false
    })
  }
  render() {
    return (
      <Templates.Default.BasePageRoute2 
      localUrl={ localUrl }
      dataPage={ this.props.DataPage }
      >
      <div className="is-main-section">
        <Card>
          <Card.Header>
             <Card.Header.Title>
                 <span className="icon"><i className="fas fa-file-invoice"></i></span>Datos
             </Card.Header.Title>
            
          </Card.Header>
          <Card.Content>
          <div ref={ this.spinnerLoad } className="ld ld-spinner  ld-spin">
              </div>
            <form  ref={ this.frmCreate }  onSubmit={ this.OnSubmit_create } className="is-hidden">
            
              { this.inputsDefault() }
            
              <hr />
              <div className="field is-horizontal">
                <div className="field-label is-normal" />
                <div className="field-body">
                  <div className="field">
                    <div className="field">
                      <div className="field-body">
                        <div className="field is-grouped">
                          <div className="control"><button type="submit"
                              className="button is-primary"><span>Guardar</span></button></div>
                          <div className="control">
                            <button type="button"
                              onClick={ this.onClick_regresar }
                              className="button is-danger"><span>Regresar</span></button></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </form>
          </Card.Content>
        </Card>
      </div>
      </Templates.Default.BasePageRoute2>
    )
  }
}

export default connect(getMapStateDefault(), {set_datapage})(CuotasExportacionCreate)